import React from 'react'
import { Pressable, StyleSheet, View } from 'react-native'

import { SafeAreaView } from 'react-native-safe-area-context'
import { StatusBar } from 'expo-status-bar'

import { router } from 'expo-router'

import { DS, DSIcon } from '@/design-system'

import { Header } from '@/components/Mini/Header'



function EntryScreen(){
  return (
    <SafeAreaView style={{flex:1, backgroundColor: DS.palette['Brand/Cream']}} edges={['top', 'bottom']}>

        <StatusBar style="dark" />

        <View style={{flex:1, gap: 32}}>        
          <ScreenHeader />
          <View style={{marginHorizontal:24, flex:1, gap:8}}>
            <SettingsButton />
            <AvatarButton />
          </View>
        </View>

    </SafeAreaView>
  )
}


function ScreenHeader(){

  function handleBack(){
    router.back();
  }
 
  const icon = 'Global/Black'
  const accent = 'Global/Black'

  return (
    <Header theme={{icon, accent}} variant="Heading 3/Medium" title="Profile" showKey={false} handler={handleBack}/> 
  )
}

function SettingsButton(){

  function handlePress(){
    router.push('/editProfile/settings')
  }

  return (
    <NavButton label="Account" iconName="Settings_Gear_Color" handler={handlePress} />
  )
}

function AvatarButton(){

  function handlePress(){
    router.push('/editProfile/avatar')
  }

  return (
    <NavButton label="Avatar" iconName="Avatar" handler={handlePress} />
  )

}

function NavButton(
    { iconName, label, handler }:
    { iconName: DSIcon, label: string, handler: () => void }) {
  //const router = useRouter()
  //const {
    //analytics: { setEvent },
    //session: { user, isTeacher, isAdmin }
  //} = useStore()

  return (
    <Pressable
      style={styles.button}
      onPress={handler}
      ////onPress={() => {
        //setEvent(events.lounge.create_lounge_tapped, {
          //userId: user?.auth0Id ?? '',
          //isTeacher,
          //isAdmin
        //})
        //router.push('/lounges/create')
      //}}
    >
      <DS.Icon name={iconName} size={24} />
      <DS.Text variant="Heading 4/Medium" style={[styles.buttonLabel, { fontSize: 24 }]}>
        {label}
      </DS.Text>
      <DS.Icon name="Arrow---right" color="Brand/Dark Grey" size={20} />
    </Pressable>
  )
}

export default EntryScreen

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 40,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    paddingHorizontal: 16,
    paddingVertical: 12,
    //marginTop: 32,
    gap: 12
  },
  buttonLabel: {
    flex: 1
  }
})


